<template>
    <div class="stepsList">
       <div class="stepsItem" v-for="(item, index) in stepsList" :key="index">
            <div class="ctime">{{item.ctime}}</div>
            <div class="user_name"><p v-html="getStringToHTML(item.name)"></p></div>
            <div class="action_text"><span v-if="item.log_type === 'scheduling'" class="sched-tag">排单</span>{{item.action_text}}</div>
            <div class="msg" v-if="!!item.msg">{{item.msg}}</div>
       </div>
    </div>
</template>
<script>
export default {
    name: 'componentsMaterialSteps',
    props: {
      stepsList:Array
    },
    data() {
        return {
            // name: '30:杨华鑫;20:李文婷;90：谢安迪'
        }
    },
    methods:{
        getStringToHTML(name) {
            let res_name = name && name.split(';')
            let list = ''
            res_name.forEach(item=>{
                list += `<p>${item}</p>`
            })
            return list
        }
    }
}
</script>
<style lang="scss" scoped>
.stepsList{
    padding-left: 15px;
    margin-left: 15px;
    border-left: 1px solid #409EFF;
    padding-bottom: 30px;
    .sched-tag{
        display: inline-block;
        font-size: 12px;
        line-height: 16px;
        padding: 0 6px;
        margin-right: 6px;
        color: #409EFF;
        border: 1px solid #409EFF;
        border-radius: 3px;
    }
    .stepsItem{
        position: relative;
        margin-bottom: 20px;
        &:before{
            content: '';
            display: block;
            width: 11px;
            height: 11px;
            background-color: #409EFF;
            border-radius: 50%;
            position: absolute;
            left: -21px;

        }
        div{
            padding-bottom: 6px;
        }
    }
}
</style>
